import SimpleBar from 'simplebar';

// KANAKAで使うSimpleBar 6.2.5。手動初期化だけを使い、終了時は元のDOMへ戻す。
export function initScrollbar(root, { axis, label, onInteract } = {}, Bar = SimpleBar) {
  const onPointerDown = (event) => {
    const track = root.querySelector(`:scope > .simplebar-track.simplebar-${axis === 'x' ? 'horizontal' : 'vertical'}`);
    if (!track) return;
    const box = track.getBoundingClientRect();
    if (box.right <= box.left || box.bottom <= box.top) return;
    if (event.clientX >= box.left && event.clientX <= box.right && event.clientY >= box.top && event.clientY <= box.bottom) onInteract?.();
  };
  // SimpleBarのトラック判定より先に、残っているLenisの慣性を止める。
  root.addEventListener('pointerdown', onPointerDown, { capture: true });
  root.classList.add('is-scrollable');
  const bar = new Bar(root, { autoHide: false, ariaLabel: label });
  let destroyed = false;
  return {
    scrollElement: bar.getScrollElement(),
    contentElement: bar.getContentElement(),
    refresh: () => { if (!destroyed) bar.recalculate(); },
    destroy() {
      if (destroyed) return;
      destroyed = true;
      root.removeEventListener('pointerdown', onPointerDown, { capture: true });
      const nodes = [...bar.getContentElement().childNodes];
      if (bar.isDragging) bar.onEndDrag();
      bar.unMount();
      root.replaceChildren(...nodes);
      root.removeAttribute('data-simplebar');
      root.classList.remove('is-scrollable', 'simplebar-dragging', 'simplebar-hover', 'simplebar-scrolling', 'simplebar-mouse-entered', 'simplebar-scrollable-x', 'simplebar-scrollable-y');
    },
  };
}
